function sanitizeString(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace("(", "%28")
    .replace(")", "%29")
    .toLowerCase()
    .replace("script", "script type='javascript/blocked'");
  // For now just escaping 7 characters but if we need to escape more chars then we can use escape()
  // too in future for chars like !@#$%^&{}[]=:/,;?+\'"\\
}

$(".st-default-search-input").on("keyup", function (e) {
  if (e.keyCode === 13) {
    let searchTerm = $(this).val();
    if (searchTerm.length) {
      window.location.href =
        "/search?stq=" +
        sanitizeString(searchTerm) +
        "#stq=" +
        sanitizeString(searchTerm);
    }
  }
});

$(".siteHeaderSearch i.icon.icon-search").on("click", function (e) {
  e.preventDefault();
  let searchTerm = $(this)
    .parents("form")
    .find(".st-default-search-input")
    .val();
  if (searchTerm.length) {
    window.location.href =
      "/search?stq=" +
      sanitizeString(searchTerm) +
      "#stq=" +
      sanitizeString(searchTerm);
  }
});

$(".mobileSearchForm button.textInputWithIcon__icon").on("click", function (e) {
  e.preventDefault();
  let searchTerm = $(this)
    .parents("form")
    .find(".st-default-search-input")
    .val();
  if (searchTerm.length) {
    window.location.href =
      "/search?stq=" +
      sanitizeString(searchTerm) +
      "#stq=" +
      sanitizeString(searchTerm);
  }
});

$(".searchBtn").on("click", function (e) {
  e.preventDefault();
  let searchTerm = $(this).parent().find(".st-default-search-input").val();
  if (searchTerm.length) {
    window.location.href =
      "/search?stq=" +
      sanitizeString(searchTerm) +
      "#stq=" +
      sanitizeString(searchTerm);
  }
});

let customRenderPaginationForType = function (type, currentPage, totalPages) {
  let pages = '<nav class="numberedPagination"><ul class="paginationGrid">';
  let previousPage = "";
  let nextPage = "";

  if (totalPages === 1) {
    return false;
  }

  if (currentPage !== 1) {
    previousPage = currentPage - 1;
    pages = `${pages}
      <li class="page page--prev">
        <a class="btn btn-pagination btn btn-pagination--text" data-hash="true" data-page="${previousPage}">
          <i class="icon icon-chevron-textLink-back "></i> 
          Prev
        </a>
      </li>`;
  }
  if (currentPage <= totalPages) {
    nextPage = currentPage + 1;
    pages =
      pages +
      `<li class=${currentPage === 1 ? `isActive abhi` : ""}>
        <a class="btn btn-pagination" data-page="1" data-hash="true">
          1
        </a>
      </li>
      ${currentPage > 1 ? `<li class="paginationEllipsis">…</li>` : ""}
      ${
        totalPages - currentPage === 1
          ? `
          ${
            currentPage - 3 > 0 &&
            currentPage - 3 !== 1 &&
            totalPages - currentPage !== 1
              ? `
                <li ${currentPage !== 1 ? `class="isActive abhi2"` : ""}>
                  <a class="btn btn-pagination" data-hash="true" data-page="${
                    currentPage - 1
                  }">
                    ${currentPage - 3}
                  </a>
                </li>`
              : ""
          }
          ${
            currentPage - 2 > 0 && currentPage - 2 !== 1
              ? `
              <li>
                <a class="btn btn-pagination" data-hash="true" data-page="${
                  currentPage - 2
                }">
                  ${currentPage - 2}
                </a>
              </li>`
              : ""
          }
          ${
            currentPage - 1 > 0 && currentPage - 1 !== 1
              ? `
              <li>
                <a class="btn btn-pagination" data-hash="true" data-page="${
                  currentPage - 1
                }">
                  ${currentPage - 1}
                </a>
              </li>`
              : ""
          }`
          : ""
      }
      ${
        currentPage === totalPages
          ? `
          ${
            currentPage - 3 > 0 && currentPage - 3 !== 1
              ? `
              <li>
                <a class="btn btn-pagination" data-hash="true" data-page="${
                  currentPage - 3
                }">
                  ${currentPage - 3}
                </a>
              </li>`
              : ""
          }
          ${
            currentPage - 2 > 0 && currentPage - 2 !== 1
              ? `
              <li>
                <a class="btn btn-pagination" data-hash="true" data-page="${
                  currentPage - 2
                }">
                  ${currentPage - 2}
                </a>
              </li>`
              : ""
          }
          ${
            currentPage - 1 > 0 && currentPage - 1 !== 1
              ? `
              <li>
                <a class="btn btn-pagination" data-hash="true" data-page="${
                  currentPage - 1
                }">
                  ${currentPage - 1}
                </a>
              </li>`
              : ""
          }`
          : ""
      }
      ${
        currentPage > 1
          ? `<li class=${currentPage !== 1 ? `isActive` : ""}>
              <a class="btn btn-pagination" data-page="${currentPage}" data-hash="true">
              ${currentPage}
              </a>
            </li>`
          : ""
      }
      ${
        totalPages - currentPage > 1 &&
        currentPage !== totalPages &&
        totalPages - currentPage !== 1
          ? `
          <li>
            <a class="btn btn-pagination" data-hash="true" data-page="${
              currentPage + 1
            }">
              ${currentPage + 1}
            </a>
          </li>
          ${
            currentPage < totalPages && currentPage !== totalPages - 2
              ? `
                <li>
                  <a class="btn btn-pagination" data-page="${
                    currentPage + 2
                  }" data-hash="true">
                    ${currentPage + 2}
                  </a>
                </li>`
              : ""
          }
          ${
            currentPage < totalPages &&
            currentPage !== totalPages - 3 &&
            currentPage !== totalPages - 2
              ? `
                <li>
                  <a class="btn btn-pagination" data-page="${
                    currentPage + 3
                  }" data-hash="true">
                    ${currentPage + 3}
                  </a>
                </li>`
              : ""
          }
          ${
            currentPage < totalPages &&
            currentPage !== totalPages - 4 &&
            currentPage + 4 < totalPages
              ? `
                <li>
                  <a class="btn btn-pagination" data-page="${
                    currentPage + 4
                  }" data-hash="true">
                    ${currentPage + 4}
                  </a>
                </li>`
              : ""
          }`
          : ""
      }
      ${
        totalPages - currentPage > 1
          ? `<li class="paginationEllipsis">…</li>`
          : ""
      }
      ${
        currentPage !== totalPages
          ? `
          <li>
            <a class="btn btn-pagination" data-page="${totalPages}" data-hash="true">
              ${totalPages}
            </a>
          </li> 
          <li class="page page--next">
            <a class="btn btn-pagination btn btn-pagination--text" data-hash="true" data-page="${nextPage}">
              Next
              <i class="icon icon-chevron-textLink"></i>
            </a>
          </li>`
          : ""
      }`;
  }
  pages += "</ul></nav>";
  return pages;
};

let customRenderFunction = function (document_type, item) {
  let resultTitle = "";
  let description = "";
  let targetBlank = 'target="_blank"';
  let isPdfLink = item["url"].match(/(\.pdf$)|(\.pdf(\?){1}.+)/);

  if (item["highlight"]["title"]) {
    resultTitle = item["highlight"]["title"];
  } else {
    resultTitle = item["title"];
  }
  if (item["highlight"]["body"]) {
    description = item["highlight"]["body"].split(" ", 22).join(" ") + " ... ";
  } else {
    description = item["body"].split(" ", 22).join(" ") + " ... ";
  }

  if (isPdfLink) {
    return `
      <li class="searchResultItem">
        <h2 class="searchResultItem__title">
          <span class="textTagWrap">
            <a href="${item["url"]}" ${targetBlank}>
              ${resultTitle}
            </a>
          </span>
        </h2>
        <div class="searchResultItem__body">
          <p>
            ${description}
          </p>
        </div>
      </li>`;
  }
  return `
    <li class="searchResultItem">
      <h2 class="searchResultItem__title">
        <span class="textTagWrap">
          <a href="${item["url"]}">
            ${resultTitle}
          </a>
        </span>
      </h2>
      <div class="searchResultItem__body">
        <p>
          ${description}
        </p>
      </div>
    </li>`;
};

let customPostRenderFunction = function (data) {
  let totalResultCount = 0;
  let $resultContainer = this.getContext().resultContainer;
  let searchQuery = data["info"]["page"]["query"];
  let resultInfo = data.info;
  let currentPage = 0;
  // let totalPages = 0;
  let startIndex = 1;
  let endIndex = 10;
  let maxPagesType,
    maxPages = -1;

  if (data["info"]) {
    $.each(data["info"], function (index, value) {
      totalResultCount += value["total_result_count"];
    });
  }

  $.each(resultInfo, function (documentType, typeInfo) {
    if (typeInfo.num_pages > maxPages) {
      maxPagesType = documentType;
      maxPages = typeInfo.num_pages;
    }
  });

  currentPage = resultInfo[maxPagesType].current_page;
  // totalPages = resultInfo[maxPagesType].num_pages;
  endIndex = endIndex * currentPage;
  if (currentPage !== 1) {
    startIndex = endIndex - 9;
  }
  if (totalResultCount === 0) {
    $resultContainer.html(
      `<div id="st-no-results" class="st-no-results">
        No results found for "${searchQuery}"
      </div>`
    );
  } else {
    $resultContainer.prepend(
      `<div class="paginationMetaHeader">
        Showing results 
        <strong>${startIndex}</strong>
          –
        <strong>${
          totalResultCount < endIndex ? totalResultCount : endIndex
        }</strong> of <strong>${totalResultCount}</strong>
        <span class="st-ui-search-summary-query"> 
          for ${searchQuery}
        </span>
      </div>`
    );
  }
};

let customOnComplete = function (data) {
  if (data.attr("target")?.toLowerCase() === "_blank") {
    window.open(data.attr("href"));
  } else {
    window.location = data.attr("href");
  }
};

$(".st-default-search-input").swiftypeSearch({
  renderFunction: customRenderFunction,
  resultContainingElement: ".st-search-container",
  renderPaginationForType: customRenderPaginationForType,
  postRenderFunction: customPostRenderFunction,
  onComplete: customOnComplete,
  engineKey: "Gdf1ZFhibyNrgYEqufVG",
});
